export default __webpack_public_path__ + "static/media/menu_icon_v.bbbd72fa.svg";